export const SESSION_STATE = {
  INIT: 'INIT',
  START: 'START',
  ACTIVE: 'ACTIVE',
  END: 'END',
};

export const REPORT_GENERATION_STATUS = {
  CTK: 'CTK',
  RGP: 'RGP',
};
